<template>
  <div class="designer-wrap">
    <FlowNav v-if="navable && !readable" :currentNav="1" :buttonName="buttonName" @click="publish" @change="change" />
    <div class="designer-base-info">
      <div class="base-info-panel" style="padding: 50px 15%">
        <el-form :label-position="'top'" label-width="80px" :model="formLabelAlign" :rules="rules" ref="formLabelAlign">
          <el-form-item label="流程名称" prop="name">
            <el-input v-model="formLabelAlign.name" placeholder="请填写流程名称"></el-input>
          </el-form-item>
          <el-form-item label="流程分类" prop="type">
            <el-select v-model="formLabelAlign.type" placeholder="请选择流程分类" style="width: 100%;">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="表单绑定" prop="forms">
            <el-select v-model="formLabelAlign.forms" placeholder="请选择绑定表单" style="width: 100%;">
              <el-option
                v-for="item in options2"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="流程备注">
            <el-input v-model="formLabelAlign.remark" placeholder="备注信息"></el-input>
          </el-form-item>
          <el-form-item>
        <el-button type="primary" @click="submitForm('formLabelAlign')">立即创建</el-button>
        <el-button @click="resetForm('formLabelAlign')">重置</el-button>
      </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { flowMixin } from '../../mixins/flowMixin';
import FlowNav from '../../Common/FlowNav.vue';
import FlowSelect from '../../Component/FlowSelect.vue';
import FlowSimpleSelect from '../../Component/FlowSimpleSelect.vue';
export default {
  name: 'BasicInfo',
  mixins: [flowMixin],
  components: { FlowNav, FlowSelect, FlowSimpleSelect },
  props: {
    navable: {
      type: Boolean,
      default: true,
    },
    readable: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      formLabelAlign: {
        name: '',
        type: '',
        forms: '',
        remark: ''
      },
      buttonName: '保存',
      options: [
        {
          value: '选项1',
          label: '公文流程'
        }, {
          value: '选项2',
          label: '请假流程'
        }
      ],
      options2: [
        {
          value: '选项1',
          label: '公文表单'
        }, {
          value: '选项2',
          label: '请假表单'
        }
      ],
      rules: {
        name: [
          { required: true, message: '请填写流程名称', trigger: 'change' },
        ],
        type: [
          { required: true, message: '请选择流程分类', trigger: 'blur' },
        ],
        forms: [
          { required: true, message: '请选择绑定表单', trigger: 'blur' },
        ]
      }
    };
  },
  computed: {},
  mounted () { },
  methods: {
    toReturn () { },
    change (type) { },
    handleSave () { },
    getData () {
      return this.nodeData;
    },
    publish () {
      this.$emit('publish', this.nodeData);
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!');
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm (formName) {
      this.$refs[formName].resetFields();
    }
  },
};
</script>
<style scoped>
.el-form-item {
  margin-top: 22px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/packages/FlowDesign/BasicInfo/index.vue